import { ChangeEvent, forwardRef } from 'react';
import styled from 'styled-components';

import { useUploadAssetsContext } from '../contexts/UploadAssetsContext';
import { inputAccept } from '../types';

const FileInput = styled.input`
  display: none !important;
`;

type Props = {
  id?: string;
};

export const testIds = {
  input: 'creative-library-hidden-file-input',
};

export const HiddenFileInput = forwardRef<HTMLInputElement, Props>(({ id = 'localFile' }, ref) => {
  const { handleNewFiles, maxBatchSize } = useUploadAssetsContext();

  // files(s) selected from file input element (click to select)
  const onFileSelect = (e: ChangeEvent<HTMLInputElement>) => {
    handleNewFiles(Array.from(e.target.files || []), () => {
      // reset the image file input (otherwise it holds a value)
      e.target.value = '';
    });
  };

  return (
    <FileInput
      accept={inputAccept.join(',')}
      data-test={testIds.input}
      id={id}
      multiple={maxBatchSize > 1}
      name={id}
      onChange={onFileSelect}
      ref={ref}
      type="file"
    />
  );
});
